import styled from '@emotion/styled';
import { FC } from 'react';

import styles from 'app/components/v2/constants/styles';
import { useAlertsDispatch } from 'app/state/AlertsContext/hooks';
import { Alert } from 'app/state/AlertsContext/Provider';

import NotificationUI, { notificationMarginRight } from './NotificationUI';

// Local Typings
interface Props {
  alerts: Alert[];
}

// Local Variables
const NotificationsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing * 2,
  position: 'fixed',
  right: notificationMarginRight,
  top: 80,
  zIndex: styles.zIndex.notification,
}));

// Component Definition
const Notifications: FC<Props> = props => {
  const alertsDispatch = useAlertsDispatch();

  function handleRemove(removeTimestamp: number) {
    alertsDispatch({
      payload: { removeTimestamp },
      type: 'removeAlert',
    });
  }

  return props.alerts.length > 0
    ? (
      <NotificationsContainer>
        {props.alerts.map((alert, i) => (
          <NotificationUI
            alert={alert}
            // eslint-disable-next-line react/no-array-index-key
            key={`${i}-${alert.timestamp}`}
            onRemove={handleRemove}
          />
        ))}
      </NotificationsContainer>
    )
    : null;
};

export default Notifications;
